module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en-us":{"title":"Performance Comparison","title_tooltip":"The section can compare locations with  KPIs. If you select a KPI from the table then it can check the trends at the bottom of the section.","maximum2selections":"Please select less than 6 locations","minimum2selections":"Please select more than 2 locations"}}')
  delete Component.options._Ctor
}
